import { render, staticRenderFns } from "./CompagniaAssicurativaDetail.vue?vue&type=template&id=fe4005ce&"
import script from "./CompagniaAssicurativaDetail.vue?vue&type=script&lang=ts&"
export * from "./CompagniaAssicurativaDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
